function createController() {
    const instances = new Map();
    const listeners = new Map();
    return {
        register(id, instance) {
            if (id) { instances.set(id, instance); }
            this.notify(id, instance?.isVisible ?? false);
        },
        unregister(id, instance) {
            if (instances.get(id) === instance) { instances.delete(id); }
        },
        show(id) { instances.get(id)?.show(); },
        hide(id) { instances.get(id)?.hide(); },
        toggle(id) { instances.get(id)?.toggle(); },
        isVisible(id) { return instances.get(id)?.isVisible ?? false; },
        subscribe(id, listener) {
            if (!listeners.has(id)) { listeners.set(id, new Set()); }
            listeners.get(id).add(listener);
            return () => listeners.get(id)?.delete(listener);
        },
        notify(id, visible) { listeners.get(id)?.forEach((listener) => listener(visible)); },
    };
}

export const modalController = createController();
let confirmRenderer = null;
modalController.configureConfirm = (renderer) => { confirmRenderer = renderer; };
modalController.msgBoxConfirm = (message, options = {}) => new Promise((resolve) => {
    if (!confirmRenderer) { resolve(null); return; }
    confirmRenderer(message, options, resolve);
});
modalController.confirm = modalController.msgBoxConfirm;

export const collapseController = createController();

const toastListeners = new Set();
let toastRenderer = null;
export const toastController = {
    configure(renderer) { toastRenderer = renderer; },
    show(message, options = {}) {
        const toast = { id: `${Date.now()}-${Math.random()}`, message, ...options };
        toastListeners.forEach((listener) => listener(toast));
        toastRenderer?.(toast);
        return toast.id;
    },
    subscribe(listener) {
        toastListeners.add(listener);
        return () => toastListeners.delete(listener);
    },
};
